<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SiteSelectBase from '../../sites/components/SiteSelectBase.vue'

// Old address of the org picker. SiteSelectBase needs an org-scoped route, so this page was
// blank; send old bookmarks to /org/select instead (E2E-R4-03)
definePage({
    redirect: '/org/select',
    meta: {
        requiresAuth: true,
        requiresOrganisation: false,
        hideHeader: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <SiteSelectBase />
</template>